import React, { useState, useRef, useEffect } from "react";
import styles from "./NavBar.module.css";
import { ReactComponent as Logo } from "../../Resources/image/logo.svg";
import { ReactComponent as Browse } from "../../Resources/image/browse.svg";
import { ReactComponent as Cart } from "../../Resources/image/cart.svg";
import { ReactComponent as GitHub } from "../../Resources/image/github.svg";
import { ReactComponent as Search } from "../../Resources/image/search.svg";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import { t } from "../../utils/i18n";

const NavBar = props => {
  const {
    handleHover,
    hoverState,
    handleHome,
    handleBrowse,
    browsing,
    landingPage,
    cart,
    cartAmount,
    search,
    searching,
    handleSearch,
    handleSearchSubmit,
    handleOpenLogin,
    handleCloseCart,
    isLoggedIn,
    handleLogout,
  } = props;

  const [showUserMenu, setShowUserMenu] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = e => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowUserMenu(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const variants = {
    hidden: { opacity: 1, y: 15 },
    visible: { opacity: 1, y: 0 },
  };

  const searchVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  const location = useLocation();

  return (
    <>
      <motion.div
        className={styles.navbar}
        animate="visible"
        initial={landingPage ? "hidden" : "visible"}
        variants={variants}
        transition={{ y: { type: "spring" }, duration: 0.01 }}
      >
        <div className={styles.navbar_left}>
          <div
            className={styles.pathdiv}
            id="1"
            onMouseEnter={handleHover}
            onMouseLeave={handleHover}
          >
            <div className={styles.searchdiv}>
              <form onSubmit={handleSearchSubmit}>
                <input
                  placeholder={t("home.search.placeholder", "Games, Topics and Collections")}
                  value={search}
                  onChange={handleSearch}
                ></input>
                <input type="submit" hidden className={styles.submit} />
                <button type="submit">
                  <Search
                    className={styles.svg}
                    style={{ fill: hoverState[7].hovered ? "#fff" : "#cccccc" }}
                    onMouseEnter={handleHover}
                    onMouseLeave={handleHover}
                    id="7"
                    aria-label={t("aria.search", "Search")}
                  />
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className={styles.navbar_right}>
          <div className={styles.userArea} id="3" ref={menuRef}>
            {isLoggedIn && handleLogout ? (
              <>
                <div
                  className={styles.avatarWrapper}
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  aria-haspopup="true"
                  aria-expanded={showUserMenu}
                >
                  <div className={styles.avatar} aria-label={t("aria.userMenu", "User menu")}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                  </div>
                </div>
                <AnimatePresence>
                  {showUserMenu && (
                    <motion.div
                      className={styles.userMenu}
                      initial={{ opacity: 0, y: -8 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -8 }}
                      transition={{ duration: 0.15 }}
                    >
                      <button
                        type="button"
                        className={styles.menuItem}
                        onClick={() => {
                          handleLogout();
                          setShowUserMenu(false);
                        }}
                      >
                        {t("home.menu.logout", "Log out")}
                      </button>
                    </motion.div>
                  )}
                </AnimatePresence>
              </>
            ) : (
              <div
                className={styles.cartdiv}
                onMouseEnter={handleHover}
                onMouseLeave={handleHover}
                onClick={handleOpenLogin}
              >
                <h3 onClick={handleOpenLogin}>
                  {t("navbar.loginCta", "Join for Free or Login")}
                </h3>
              </div>
            )}
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default NavBar;
